import { ActionConfig, ActionContext } from '../../../logic/types'
import { DepositToWethAction } from '../types'
import { wethAbi, wethAddress } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'

export function createDepositToWethActionConfig(action: DepositToWethAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      const value = action.eth.toBigInt(action.value)

      return ensureConfigTypes({
        abi: wethAbi,
        address: getContractAddress(wethAddress, chainId),
        functionName: 'deposit',
        value,
      })
    },

    invalidates: () => [getBalancesQueryKeyPrefix({ chainId, account })],
  }
}
